;(function(){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sweetalert = require('sweetalert2');

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Vue.component('merchant-basic-details', require('./MerchantBasicDetailsComponent.vue'));
Vue.component('merchant-bank-details', require('./MerchantBankDetailsComponent.vue'));
Vue.component('merchant-revenue-share', require('./MerchantRevenueShareComponent.vue'));
Vue.component('merchant-exempted-gateways', require('./MerchantExemptedGatewaysComponent.vue'));
Vue.component('merchant-payment-config', require('./MerchantPaymentConfigComponent.vue'));
Vue.component('merchant-commission-config', require('./MerchantCommissionConfigComponent.vue'));
Vue.component('merchant-settlement-config', require('./MerchantSettlementConfigComponent.vue'));
Vue.component('merchant-meta-data-config', require('./MerchantMetaDataConfigComponent.vue'));
exports.default = {
  name: "MerchantEditForm",
  props: ["gateways", "banks", "currencies", "commissions", "csrftoken", "action", "existing_merchant", "merchant_bank_accounts"],
  data: function data() {
    return {
      modal_merchant_name: null,
      merchant: {
        name: null,
        description: null,
        email: null,
        phone: "",
        notification_url: null,
        payment_code: "",
        pesaflow_commission_exempted: false,
        ubi: null,
        metadata: [],
        rev_shares: [],
        allow_partial_payment: "true",
        commission_configurations: [],
        bank_accounts: [],
        settlement_configuration: {},
        exempted_gateways: [],
        _csrf_token: null
      },
      available_gateways: [],
      banksListing: [],
      currencyList: [],
      csrfToken: null,
      currentAction: "Edit"
    };
  },
  beforeMount: function beforeMount() {
    this.currentAction = this.action;
    if (this.existing_merchant) {
      this.merchant = JSON.parse(this.existing_merchant);
    }
    this.merchant.bank_accounts = JSON.parse(this.merchant_bank_accounts);
    console.log("ALL BANK ACCS", this.merchant.bank_accounts);
    this.available_gateways = JSON.parse(this.gateways);
    this.banksListing = this.banks;
    this.currencyList = this.currencies;
    this._csrf_token = this.csrftoken;
  },
  mounted: function mounted() {
    if (this.existing_merchant) {
      this.merchant = JSON.parse(this.existing_merchant);
    }
    this.merchant.bank_accounts = JSON.parse(this.merchant_bank_accounts);
  },

  methods: {
    addBasicDetails: function addBasicDetails(details) {
      this.merchant.name = details.name;
      this.merchant.description = details.description;
    },
    addCommissionConfigToRecord: function addCommissionConfigToRecord(details) {
      this.merchant.pesaflow_commission_exempted = details.pesaflow_commission_exempted;
      this.merchant.commission_configurations = details.selected_commission_setups;
    },

    addPaymentConfigToList: function addPaymentConfigToList(details) {
      this.merchant.allow_partial_payment = details.allow_partial_payment;
      this.merchant.payment_code = details.payment_code;
      this.merchant.notification_url = details.notification_url;
      this.merchant.email = details.email;
      this.merchant.phone = details.phone;
    },

    addBankToList: function addBankToList(details) {
      this.merchant.bank_accounts.push(details);
    },
    reMoveBank: function reMoveBank(details) {
      this.merchant.bank_accounts = details;
    },

    addRevShareToList: function addRevShareToList(details) {
      this.merchant.rev_shares.push(details);
    },

    removeRevShare: function removeRevShare(updatedList) {
      this.merchant.rev_shares = updatedList;
    },

    addGatewayToRecord: function addGatewayToRecord(details) {
      this.merchant.exempted_gateways = details;
    },
    addMetaDataToRecord: function addMetaDataToRecord(details) {
      this.merchant.metadata = details;
    },
    addSettlementToRecord: function addSettlementToRecord(details) {
      this.merchant.settlement_configuration = details;
    },
    editMerchant: function editMerchant() {
      var merchant_id = this.merchant.id;
      if (merchant_id !== undefined || null) {
        Vue.axios.put('/' + merchant_id + '/edit', { merchant_params: this.merchant, merchant_id: merchant_id }, {
          headers: {
            "x-csrf-token": this.csrftoken
          }
        }).then(function (response) {
          if (response.status == 200) {
            _sweetalert2.default.fire({
              position: "top-end",
              icon: "success",
              title: "Edited merchant details successfully",
              showConfirmButton: false,
              timer: 3000
            });
            window.location.replace("/merchants");
          }
        }).catch(function (error) {
          if (error.message) {
            _sweetalert2.default.fire({
              position: "top-end",
              icon: "error",
              title: "Error Editing Merchant",
              showConfirmButton: false,
              timer: 3000
            });
          }
        });
      }
    },
    addTier: function addTier() {},
    toggle_can_receive_notification: function toggle_can_receive_notification(value) {
      if (value === "api") {
        if (this.merchant.can_receive_notifications) {
          this.merchant.can_receive_notifications = true;
        } else {
          this.merchant.can_receive_notifications = false;
        }
      }
      if (value === "email") {
        if (this.merchant.can_receive_email) {
          this.merchant.can_receive_email = true;
        } else {
          this.merchant.can_receive_email = false;
        }
      }
      if (value === "sms") {
        if (this.merchant.can_receive_sms) {
          this.merchant.can_receive_sms = true;
        } else {
          this.merchant.can_receive_sms = false;
        }
      }
    }
  },
  computed: {
    merchantCommissions: function merchantCommissions() {
      return JSON.parse(this.existing_merchant).commission_configurations;
    },
    merchantCommissionsExempted: function merchantCommissionsExempted() {
      return JSON.parse(this.existing_merchant).pesaflow_commission_exempted;
    },
    bankListingAvailable: function bankListingAvailable() {
      if (this.banksListing.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    commissionListingAvailable: function commissionListingAvailable() {
      if (this.commissionList.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    gatewaysListingAvailable: function gatewaysListingAvailable() {
      if (this.available_gateways.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    commissionList: function commissionList() {
      return JSON.parse(this.commissions);
    },
    paymentConfiguration: function paymentConfiguration() {
      return {
        email: this.existingMerchantData.email,
        allow_partial_payment: this.existingMerchantData.allow_partial_payment,
        phone: this.existingMerchantData.phone,
        notification_url: this.existingMerchantData.notification_url,
        payment_code: this.existingMerchantData.payment_code
      };
    },
    existingMerchantData: function existingMerchantData() {
      if (this.existing_merchant) {
        return JSON.parse(this.existing_merchant);
      } else {
        return this.merchant;
      }
    },
    basicDetails: function basicDetails() {
      return {
        name: this.existingMerchantData.name,
        description: this.existingMerchantData.description
      };
    },
    existingRevShares: function existingRevShares() {
      return this.existingMerchantData.rev_shares;
    },
    currentMetaData: function currentMetaData() {
      return this.existingMerchantData.metadata;
    },
    merchantBanks: function merchantBanks() {
      return this.merchant.bank_accounts;
    },
    existingSettlementsConfig: function existingSettlementsConfig() {
      return JSON.parse(this.existing_merchant).settlement_configuration;
    },
    existingCommissionConfiguration: function existingCommissionConfiguration() {
      return {
        label: this.existingMerchantData.commission_configurations.commission_configuration.name,
        id: this.existingMerchantData.commission_configurations.commission_configuration.id
      };
    },
    exemptedGateways: function exemptedGateways() {
      return this.existing_merchant.exempted_gateways;
    },
    isCommissionExempted: function isCommissionExempted() {
      return this.merchant.pesaflow_commission_exempted;
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"header mt-md-5"},[_c('div',{staticClass:"header-body"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('a',{staticClass:"text-muted",attrs:{"href":"/merchants"}},[_vm._v("Merchants")]),_vm._v(" "),_c('svg',{staticClass:"pt-1 ml-2",attrs:{"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6 12.5L10 8.5L6 4.5","stroke":"#667085","stroke-width":"1.33333","stroke-linecap":"round","stroke-linejoin":"round"}})]),_vm._v(" "),_c('p',{staticClass:"font-weight-semibold text-dark ml-2 mb-0 mt-1"},[_vm._v(" Edit Merchant")])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column flex-md-row justify-content-between md-align-items-center mt-2"},[_c('h1',{staticClass:"header-title"},[_vm._v("Edit Merchant")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center mt-4 mt-md-0"},[_c('a',{staticClass:"px-3 py-2 btn-outline-danger btn rounded-lg d-flex justify-content-center align-items-center text-sm font-weight-bold",attrs:{"href":"/merchants"}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.currentAction == 'Edit')?_c('button',{staticClass:"px-3 py-2 btn-primary ml-3 btn rounded-lg d-flex justify-content-center align-items-center text-sm font-weight-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.editMerchant()}}},[_vm._v("\n                  Save Changes\n                ")]):_vm._e()])])])])])]),_vm._v(" "),_c('div',{staticClass:"row mx-1"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card mx-lg-0 col-lg-6"},[_c('div',{},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mt-3 px-2"},[_c('p',{staticClass:"text-dark font-weight-medium m-0"},[_vm._v("Basic Details")]),_vm._v(" "),_c('button',{staticClass:"px-3 py-2 btn-outline-primary btn rounded-lg d-flex justify-content-center align-items-center text-sm font-weight-bold",attrs:{"type":"button","data-toggle":"modal","data-target":"#createMerchantModal"}},[_vm._v(_vm._s(_vm.currentAction))])]),_vm._v(" "),_c('hr',{staticStyle:{"margin":"12px -14px"}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"py-3 mb-2 rounded-lg",staticStyle:{"background-color":"#f9fbfd"}},[_c('div',{staticClass:"px-4 py-1.5 bg-slate-50 rounded-md"},[_c('p',{staticClass:"text-xs font-medium leading-tight text-gray-500 m-0"},[_vm._v("Merchant")]),_vm._v(" "),_c('p',{staticClass:"text-xs font-medium leading-tight m-0 mt-2"},[_vm._v(_vm._s(_vm.merchant.name))])])]),_vm._v(" "),_c('div',{staticClass:"py-3 mb-2 mt-2 rounded-lg",staticStyle:{"background-color":"#f9fbfd"}},[_c('div',{staticClass:"px-4 py-1.5 bg-slate-50 rounded-md"},[_c('p',{staticClass:"text-xs font-medium leading-tight text-gray-500 m-0"},[_vm._v("Description")]),_vm._v(" "),_c('p',{staticClass:"text-xs font-medium leading-tight m-0 mt-2"},[_vm._v(_vm._s(_vm.merchant.description))])])])])]),_vm._v(" "),_c('merchant-basic-details',{attrs:{"basicDetails":_vm.basicDetails,"actionName":_vm.currentAction},on:{"addbasicdetails":_vm.addBasicDetails}})],1),_vm._v(" "),(_vm.bankListingAvailable)?_c('merchant-bank-details',{attrs:{"existingBanks":_vm.merchant.bank_accounts,"allBanks":_vm.banksListing,"allCurrencies":_vm.currencyList,"actionName":_vm.currentAction},on:{"addbankrecord":_vm.addBankToList,"removebankacc":_vm.reMoveBank}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card mx-lg-0 col-lg-6"},[_c('div',{},[_vm._m(1),_vm._v(" "),_c('hr',{staticStyle:{"margin":"12px -14px"}}),_vm._v(" "),_c('div',{staticClass:"py-3 mb-2 rounded-lg",staticStyle:{"background-color":"#f9fbfd"}},[_c('div',{staticClass:"px-4 py-1.5 bg-slate-50 rounded-md"},[_c('p',{staticClass:"text-xs font-medium leading-tight text-gray-500 m-0"},[_vm._v("Allow partial payments")]),_vm._v(" "),_c('p',{staticClass:"text-xs font-medium leading-tight m-0 mt-2"},[_vm._v(_vm._s(_vm.merchant.allow_partial_payment))])])]),_vm._v(" "),_c('div',{staticClass:"py-3 mb-2 rounded-lg",staticStyle:{"background-color":"#f9fbfd"}},[_c('div',{staticClass:"px-4 py-1.5 bg-slate-50 rounded-md"},[_c('p',{staticClass:"text-xs font-medium leading-tight text-gray-500 m-0"},[_vm._v("Payment Code/ Prefix")]),_vm._v(" "),_c('p',{staticClass:"text-xs font-medium leading-tight m-0 mt-2"},[_vm._v(_vm._s(_vm.merchant.payment_code))])])]),_vm._v(" "),_c('div',{staticClass:"py-3 mb-2 mt-2 rounded-lg",staticStyle:{"background-color":"#f9fbfd"}},[_c('div',{staticClass:"px-4 py-1.5 bg-slate-50 rounded-md"},[_c('p',{staticClass:"text-xs font-medium leading-tight text-gray-500 m-0"},[_vm._v("Receive API Notifications")]),_vm._v(" "),_c('p',{staticClass:"text-xs font-medium leading-tight m-0 mt-2"},[_vm._v(_vm._s(_vm.merchant.notification_url))])])]),_vm._v(" "),_c('div',{staticClass:"py-3 mb-2 mt-2 rounded-lg",staticStyle:{"background-color":"#f9fbfd"}},[_c('div',{staticClass:"px-4 py-1.5 bg-slate-50 rounded-md"},[_c('p',{staticClass:"text-xs font-medium leading-tight text-gray-500 m-0"},[_vm._v("Receive Email Notifications")]),_vm._v(" "),_c('p',{staticClass:"text-xs font-medium leading-tight m-0 mt-2"},[_vm._v(_vm._s(_vm.merchant.email))])])]),_vm._v(" "),_c('div',{staticClass:"py-3 mb-2 mt-2 rounded-lg",staticStyle:{"background-color":"#f9fbfd"}},[_c('div',{staticClass:"px-4 py-1.5 bg-slate-50 rounded-md"},[_c('p',{staticClass:"text-xs font-medium leading-tight text-gray-500 m-0"},[_vm._v("Receive SMS Notifications")]),_vm._v(" "),_c('p',{staticClass:"text-xs font-medium leading-tight m-0 mt-2"},[_vm._v(_vm._s(_vm.merchant.phone))])])])])]),_vm._v(" "),_c('merchant-payment-config',{attrs:{"paymentConfig":_vm.paymentConfiguration,"actionName":_vm.currentAction},on:{"addpaymentconfig":_vm.addPaymentConfigToList}}),_vm._v(" "),_c('merchant-commission-config',{attrs:{"selectedCommissionConfigs":_vm.merchantCommissions,"pesaflowCommissionExempted":_vm.merchant.pesaflow_commission_exempted,"commissionSetups":_vm.commissionList,"actionName":_vm.currentAction},on:{"addcommissionconfig":_vm.addCommissionConfigToRecord}}),_vm._v(" "),_c('merchant-settlement-config',{attrs:{"existingSettlementConfig":_vm.merchant.settlement_configuration,"listedBankAccounts":_vm.merchantBanks,"actionName":_vm.currentAction},on:{"addsettlemtconfig":_vm.addSettlementToRecord}}),_vm._v(" "),_c('merchant-revenue-share',{attrs:{"existingRevShares":_vm.merchant.rev_shares,"actionName":_vm.currentAction},on:{"addrevsharerecord":_vm.addRevShareToList,"updaterevshares":_vm.removeRevShare}}),_vm._v(" "),(_vm.gatewaysListingAvailable)?_c('merchant-exempted-gateways',{attrs:{"allExemptedGatewayList":_vm.merchant.exempted_gateways,"gatewaysList":_vm.available_gateways,"actionName":_vm.currentAction},on:{"addgatewaystolist":_vm.addGatewayToRecord}}):_vm._e(),_vm._v(" "),_c('merchant-meta-data-config',{attrs:{"existingMetaData":_vm.currentMetaData,"actionName":_vm.currentAction},on:{"addmetadata":_vm.addMetaDataToRecord}})],1)])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 d-none"},[_c('div',{staticClass:"card margin-bottom-0"},[_c('div',{staticClass:"card-body"})])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-between align-items-center mt-3 px-2"},[_c('p',{staticClass:"text-dark font-weight-medium m-0"},[_vm._v("Payment Configuration")]),_vm._v(" "),_c('button',{staticClass:"px-3 py-2 btn-outline-primary btn rounded-lg d-flex justify-content-center align-items-center text-sm font-weight-bold",attrs:{"type":"button","data-toggle":"modal","data-target":"#paymentConfigModal"}},[_vm._v("Edit")])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-614727d4", __vue__options__)
  } else {
    hotAPI.reload("data-v-614727d4", __vue__options__)
  }
})()}